import Typography from "@material-ui/core/Typography";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  List
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TopSellingProductProps } from "./types";
import { TopSellingProduct } from "./TopSellingProduct";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "./styles";
import useModuleStyles from "../../styles";
import { Fastfood } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FilteredStoresState } from "../../../../store/stores/types";
import { AppState } from "../../../../store";
import { collection, onSnapshot, query } from "firebase/firestore";
import {
  firebase,
  logFirestoreError,
  dateAndTenantConstraints,
  includesStoreId
} from "../../../../firebase";
import { InclVat } from "../inclVat";
import { useI18n } from "../../../../hooks/useI18n";

export const TopSellingProducts = () => {
  const theme = useTheme();
  const classes = useStyles();
  const moduleClasses = useModuleStyles();
  const { t } = useI18n();
  const [products, setProducts] =
    useState<TopSellingProductProps[]>([]) ||
    new Array<TopSellingProductProps>();
  const [isLoading, setIsLoading] = useState(true);

  const filteredStoresState = useSelector<AppState, FilteredStoresState>(
    s => s.filteredStores
  );

  useEffect(() => {
    if (!filteredStoresState || filteredStoresState?.stores.length === 0) {
      setIsLoading(false);
      return;
    }

    const storeids = filteredStoresState?.stores
      .filter(s => s.state === "Opened")
      .map(x => x.id);

    if (storeids.length == 0) {
      return;
    }

    const q = query(
      collection(firebase.firestore, "ProductSale"),
      ...dateAndTenantConstraints(filteredStoresState.stores)
    );

    const unsubscribe = onSnapshot(
      q,
      snapShot => {
        let prods = [] as TopSellingProductProps[];
        snapShot.docs.forEach(doc => {
          const data = doc.data();
          if (includesStoreId(storeids, data.StoreId)) {
            prods.push({
              ranking: 0,
              productId: data.ProductId,
              productName: data.ProductName,
              amountSoldTotal: data.TotalSales
            });
          }
        });
        prods.sort((a, b) => b.amountSoldTotal - a.amountSoldTotal);
        setProducts(
          prods.slice(0, 6).map((p, i) => ({ ...p, ranking: i + 1 }))
        );
        setIsLoading(false);
      },
      error => {
        logFirestoreError("ProductSale")(error);
        setIsLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [filteredStoresState]);

  return (
    <Card className={classes.listContainer}>
      <CardContent>
        <Box>
          {!isLoading ? (
            <></>
          ) : (
            <div className={moduleClasses.spinnerContainer}>
              <CircularProgress />
            </div>
          )}
        </Box>
        <Grid
          wrap="nowrap"
          spacing={2}
          justifyContent={"space-between"}
          container
        >
          <Grid item style={{ alignItems: "center", display: "flex" }}>
            <Typography color="textPrimary" gutterBottom variant="button">
              {t("common.messages.topSellingProducts")}
            </Typography>
          </Grid>
          <Grid item className={""}>
            <Avatar
              style={{
                backgroundColor: `${theme.palette.primary.main}`,
                width: "3.2rem",
                height: "3.2rem"
              }}
            >
              <Fastfood fontSize={"large"} />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <List
            component="div"
            style={{ width: "100%" }}
            className={classes.productList}
          >
            {products.map((p, i) => {
              return <TopSellingProduct {...p} ranking={i + 1} key={i} />;
            })}
          </List>
        </Box>
        <InclVat />
      </CardContent>
    </Card>
  );
};
